<template>
  <div>
    <!-- redpipe settings -->
    <p class="title is-5">RedPipe client</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API host</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="redPipeSettings.client.apiHost" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API key</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="redPipeSettings.client.apiKey" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="redPipeSettings.client.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <p class="title is-5">RedPipe server</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API key</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="redPipeSettings.server.apiKey" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import redpipeService from '../../../../services/redpipe.service';

  export default {
    name: 'client-settings-redpipe',
    data() {
      return {
        redPipeSettings: {
          server: {},
          client: {}
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.redPipeSettings = await redpipeService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await redpipeService.save(this.clientId, this.redPipeSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/redpipe.vue